import React from 'react';

const Privacidade = () => (
  <div className="max-w-3xl mx-auto px-6 py-32 text-white">
    <h1 className="text-4xl font-extrabold mb-2">Política de Privacidade</h1>
    <p className="text-white/50 text-sm mb-10">Última atualização: maio de 2026</p>

    <p className="text-white/70 leading-relaxed mb-8">
      Esta Política de Privacidade descreve como o Anjora ("nós", "nosso") coleta, usa e protege as informações dos usuários do aplicativo Anjora (com.anjora.app).
    </p>

    {[
      {
        title: '1. Informações que coletamos',
        content: 'O Anjora foi projetado com privacidade como prioridade. Coletamos apenas o mínimo necessário para o funcionamento do serviço: E-mail (utilizado para criar sua conta e enviar informações sobre o plano) e dados de uso do plano (data de início, tipo de plano e status de acesso).'
      },
      {
        title: '2. O que NÃO coletamos',
        content: 'O Anjora não coleta, armazena nem compartilha: conteúdo das páginas que você visita, histórico de navegação, dados bancários ou financeiros, localização geográfica, contatos ou arquivos do dispositivo.'
      },
      {
        title: '3. Como usamos suas informações',
        content: 'Usamos seu e-mail exclusivamente para: autenticação na conta, envio de informações sobre seu plano e suporte ao cliente quando solicitado.'
      },
      {
        title: '4. Compartilhamento de dados',
        content: 'Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins comerciais. Seus dados podem ser compartilhados apenas com provedores de serviço essenciais (como processadores de pagamento) e quando exigido por lei.'
      },
      {
        title: '5. Segurança',
        content: 'Utilizamos criptografia e boas práticas de segurança para proteger seus dados. O processamento de proteção ocorre localmente no seu dispositivo — nenhum conteúdo de tela é transmitido para nossos servidores.'
      },
      {
        title: '6. Seus direitos (LGPD)',
        content: 'Em conformidade com a Lei Geral de Proteção de Dados (LGPD), você tem direito a: acessar seus dados, corrigir informações incorretas, solicitar a exclusão dos seus dados e revogar consentimento a qualquer momento. Para exercer esses direitos, entre em contato: suporte@anjora.com.br'
      },
      {
        title: '7. Retenção de dados',
        content: 'Seus dados são mantidos enquanto sua conta estiver ativa. Após cancelamento, os dados são excluídos em até 90 dias.'
      },
      {
        title: '8. Contato',
        content: 'Dúvidas sobre privacidade: suporte@anjora.com.br'
      }
    ].map((item, i) => (
      <div key={i} className="mb-8">
        <h2 className="text-xl font-bold mb-3 text-blue-400">{item.title}</h2>
        <p className="text-white/70 leading-relaxed">{item.content}</p>
      </div>
    ))}
  </div>
);

export default Privacidade;
